<template>
  <div class="ma-4">
    <v-snackbar v-model="msg" top>
      {{ text }}
      <v-btn color="pink" text @click="msg = false"> Close</v-btn></v-snackbar
    >
    <v-card>
      <v-layout row wrap class="pa-2 ma-2 hideOnPrint">
        <v-flex xs12>
          <v-btn fab x-small @click="$router.go(-1)">
            <v-icon>navigate_before</v-icon>
          </v-btn>
        </v-flex>

        <v-flex xs12 md1 class="mb-2">
          <v-btn
            fab
            small
            @click="printReport()"
            class="ml-8 white--text"
            color="#2b6993"
            elevation="4"
            absolute
            right
          >
            <v-icon>print</v-icon>
          </v-btn>
        </v-flex>

        <v-flex xs12>
          <h3 class="text-center mb-5">Client List</h3>
          <v-divider class="ml-4 mr-4 mb-3"></v-divider>
        </v-flex>

        <v-row>
          <v-col cols="12">
            <v-select
              v-model="reportFilters.ClientStatus"
              :items="status"
              label="Status"
              class="ml-4 mr-4 mb-3"
              @change="onSelectItem"
              clearable
            ></v-select>
          </v-col>
        </v-row>

        <v-flex xs12 class="pa-2">
          <v-data-table
            :headers="headers"
            :items="clients"
            sort-by="Name"
            sort-asc
            class="elevation-1"
            :loading="isLoading"
            loading-text="Loading Clients"
            :items-per-page="100"
          >
            <template v-slot:item.select="{ item }">
              <v-btn
                x-small
                class="white--text"
                color="#2b3990"
                @click="viewClient(item)"
              >
                view
              </v-btn>
            </template>
          </v-data-table>
        </v-flex>
      </v-layout>
    </v-card>

    <v-dialog v-model="dialog" max-width="100%">
      <template v-slot:activator="{ on }" v-if="showButton">
        <v-btn
          color="#2b3990"
          class="mb-2 white--text"
          v-on="on"
          @click="showAdd()"
        >
          <v-icon left>add</v-icon>
          Add Client</v-btn
        >
      </template>
      <v-card>
        <v-card-title style="background-color: #2b3990">
          <span class="headline white--text">{{ titleForm }}</span>
        </v-card-title>
        <v-card-text>
          <validation-observer ref="observer">
            <v-container>
              <v-row>
                <v-col cols="12" sm="12" md="4">
                  <validation-provider
                    v-slot="{ errors }"
                    name="Client Name"
                    rules="required"
                  >
                    <v-text-field
                      v-model="newName"
                      label="Client Name"
                      :error-messages="errors"
                    ></v-text-field>
                  </validation-provider>
                </v-col>
                <v-col cols="12" sm="12" md="4">
                  <v-datetime-picker
                    v-model="newAdmissionDate"
                    :text-field-props="textFieldProps"
                    :time-picker-props="endTimeProps"
                    time-format="hh:mm a"
                    date-format="MM/dd/yyyy"
                    label="Admission Date"
                  ></v-datetime-picker>
                </v-col>
                <!-- <v-col cols="12" sm="12" md="6">
                      <v-select
                        label="Service Codes"
                        v-model="newServiceCode"
                        outlined
                        :items="codes"
                        item-value="Code"
                        item-text="Code"
                        multiple
                      ></v-select>
                    </v-col> -->
                <v-col cols="12" sm="12" md="4">
                  <validation-provider
                    v-slot="{ errors }"
                    name="Program"
                    rules="required"
                  >
                    <v-autocomplete
                      class="d-flex"
                      v-model="newProgram"
                      :items="units"
                      item-text="Name"
                      item-value="Name"
                      label="Program"
                      multiple
                      :error-messages="errors"
                    ></v-autocomplete>
                  </validation-provider>
                </v-col>
                <v-col cols="12" sm="12">
                  <validation-provider
                    v-slot="{ errors }"
                    name="Client Bio"
                    rules="required"
                  >
                    <v-textarea
                      v-model="newBio"
                      outlined
                      label="Client Bio"
                      :error-messages="errors"
                    ></v-textarea>
                  </validation-provider>
                </v-col>
                <v-col>
                  <v-menu
                    ref="menu3"
                    v-model="menu3"
                    :close-on-content-click="false"
                    :return-value.sync="date"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        v-model="newBirthday"
                        label="Birthday"
                        prepend-icon="mdi-calendar"
                        readonly
                        v-bind="attrs"
                        v-on="on"
                        clearable
                      ></v-text-field>
                    </template>
                    <v-date-picker v-model="newBirthday" no-title scrollable>
                      <v-spacer></v-spacer>
                      <v-btn text color="primary" @click="menu3 = false">
                        Cancel
                      </v-btn>
                      <v-btn
                        text
                        color="primary"
                        @click="$refs.menu3.save(date)"
                      >
                        OK
                      </v-btn>
                    </v-date-picker>
                  </v-menu>
                </v-col>
                <v-col cols="12" sm="12" md="6">
                  <validation-provider
                    v-slot="{ errors }"
                    name="Age"
                    rules="required"
                  >
                    <v-text-field
                      v-model="newAge"
                      label="Age"
                      :error-messages="errors"
                    ></v-text-field>
                  </validation-provider>
                </v-col>
                <v-col cols="12" sm="12" md="6">
                  <validation-provider
                    v-slot="{ errors }"
                    name="Gender"
                    rules="required"
                  >
                    <v-select
                      v-model="newGender"
                      label="Gender"
                      :items="gender"
                      :error-messages="errors"
                    ></v-select>
                  </validation-provider>
                </v-col>
                <v-col cols="12" sm="12" md="6">
                  <validation-provider
                    v-slot="{ errors }"
                    name="Ethnicity"
                    rules="required"
                  >
                    <v-text-field
                      v-model="newEthnicity"
                      label="Ethnicity"
                      :error-messages="errors"
                    ></v-text-field>
                  </validation-provider>
                </v-col>
                <!-- <v-col cols="12" sm="12" md="6">
                      <v-textarea
                        v-model="newAllergies"
                        label="Allergies"
                        outlined
                      ></v-textarea>
                    </v-col> -->
                <!-- <v-col cols="12" sm="12" md="6">
                      <v-textarea
                        v-model="newBehaviors"
                        label="Behaviors"
                        outlined
                      ></v-textarea>
                    </v-col> -->
                <v-col cols="12" sm="12" md="6">
                  <validation-provider
                    v-slot="{ errors }"
                    name="Medicare"
                    rules="required"
                  >
                    <v-text-field
                      v-model="newMedicare"
                      label="Medicare Number"
                      :error-messages="errors"
                    ></v-text-field>
                  </validation-provider>
                </v-col>
                <v-col cols="12" sm="12" md="6">
                  <validation-provider
                    v-slot="{ errors }"
                    name="Medicaid"
                    rules="required"
                  >
                    <v-text-field
                      v-model="newMedicaid"
                      label="Medicaid Number"
                      :error-messages="errors"
                    ></v-text-field>
                  </validation-provider>
                </v-col>
                <v-col cols="12" sm="12" md="6">
                  <validation-provider
                    v-slot="{ errors }"
                    name="PID"
                    rules="required"
                  >
                    <v-text-field
                      v-model="newPID"
                      label="PID"
                      :error-messages="errors"
                    ></v-text-field>
                  </validation-provider>
                </v-col>
                <v-col cols="12" sm="12" md="6">
                  <validation-provider
                    v-slot="{ errors }"
                    name="Case Number"
                    rules="required"
                  >
                    <v-text-field
                      v-model="newCase"
                      label="Case Number"
                      :error-messages="errors"
                    ></v-text-field>
                  </validation-provider>
                </v-col>

                <v-col cols="12" sm="12" md="6">
                  <validation-provider
                    v-slot="{ errors }"
                    name="State"
                    rules="required"
                  >
                    <v-select
                      v-model="newState"
                      label="State Receving Services In"
                      :items="states"
                      :error-messages="errors"
                    ></v-select>
                  </validation-provider>
                </v-col>

                <v-col cols="12" sm="12" md="6" v-if="newState == 'Nevada'">
                  <validation-provider name="Wellsky Number">
                    <v-text-field
                      v-model="newWellsky"
                      label="Wellsky Number"
                    ></v-text-field>
                  </validation-provider>
                </v-col>

                <v-col cols="12" sm="12" md="6">
                  <span>Does the client have adaptive equipment?</span>
                  <v-switch
                    v-model="newAdaptiveEquipment"
                    label="Yes"
                  ></v-switch>
                </v-col>

                <v-col cols="12" md="6" v-if="newAdaptiveEquipment">
                  <v-menu
                    ref="menu"
                    v-model="menu"
                    :close-on-content-click="false"
                    :return-value.sync="date"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        v-model="newAdaptiveDate"
                        label="Date"
                        prepend-icon="mdi-calendar"
                        readonly
                        v-bind="attrs"
                        v-on="on"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="newAdaptiveDate"
                      no-title
                      scrollable
                    >
                      <v-spacer></v-spacer>
                      <v-btn text color="primary" @click="menu = false">
                        Cancel
                      </v-btn>
                      <v-btn
                        text
                        color="primary"
                        @click="$refs.menu.save(date)"
                      >
                        OK
                      </v-btn>
                    </v-date-picker>
                  </v-menu>
                </v-col>

                <v-col cols="12" md="6" v-if="newAdaptiveEquipment">
                  <v-text-field
                    label="Equipment Used"
                    v-model="newEquipmentUsed"
                  ></v-text-field>
                </v-col>

                <v-col cols="12" v-if="newAdaptiveEquipment">
                  <span>Is it used daily?</span>
                  <v-switch label="Yes" v-model="newDailyUse"></v-switch>
                </v-col>

                <v-col cols="12" v-if="!newDailyUse && newAdaptiveEquipment">
                  <v-textarea
                    label="If no, explain how often it's needed"
                    v-model="newExplanation"
                    outlined
                  ></v-textarea>
                </v-col>

                <v-col cols="12">
                  <v-text-field
                    label="Home Address"
                    v-model="newAddress"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="4">
                  <v-text-field label="City" v-model="newCity"></v-text-field>
                </v-col>
                <v-col cols="12" md="4">
                  <v-text-field
                    label="State"
                    v-model="newAddressState"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="4">
                  <v-text-field label="Zip" v-model="newZip"></v-text-field>
                </v-col>
              </v-row>
            </v-container>
          </validation-observer>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            class="white--text"
            color="#259647"
            @click="onAddClient(newClient)"
            v-if="newClient"
            >Save</v-btn
          >
          <v-btn
            color="blue darken-1"
            text
            @click="updateClient(newClient)"
            v-if="editClient"
            >Update</v-btn
          >
          <v-btn color="blue darken-1" text @click="close">Cancel</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <div id="print">
      <h2 class="text-center ma-3">Active Clients</h2>
      <v-row>
        <v-col cols="12">
          <v-data-table
            :headers="headers"
            :items="clients"
            sort-by="Name"
            sort-asc
            class="elevation-1"
            :loading="isLoading"
            loading-text="Loading Clients"
            :items-per-page="-1"
          >
          </v-data-table>
        </v-col>
      </v-row>
    </div>
  </div>
</template>
<script>
import axios from "axios";
import moment from "moment";
import reports from "@/mixins/reports";
import ReportFilters from "@/mixins/reportFilters";

const url = require("../../client_config/config").url;

export default {
  components: {},
  mixins: [reports, 
    ReportFilters
  ],
  data: () => ({
    headers: [
      {
        text: "Name",
        align: "start",
        sortable: true,
        value: "Name",
      },
      { text: "Program", value: "Program" },
      { text: "Birthday", value: "Birthday" },
      { text: "Admission Date", value: "AdmissionDate" },
      { text: "Actions", value: "actions" },
    ],
    date: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
      .toISOString()
      .substr(0, 10),
    clients: [],
    dialog: false,
    editClient: false,
    newClient: false,
    msg: false,
    search: "",
    text: "",
    menu3: false,
    menu: false,
    units: [],
    codes: [],
    gender: ["Male", "Female"],
    unitID: localStorage.getItem("unitID"),
    userProgram: JSON.parse(localStorage.getItem("userPrograms")),
    userState: localStorage.getItem("userState"),
    userRole: localStorage.getItem("userRole"),
    titleForm: "New Client",
    clientID: "",
    savedID: "",
    newName: "",
    newAdmissionDate: new Date(),
    newServiceCode: [],
    newProgram: [],
    newBio: "",
    newBirthday: "",
    newAge: "",
    newGender: "",
    newEthnicity: "",
    newAllergies: "",
    newBehaviors: "",
    newMedicare: "",
    newMedicaid: "",
    newPID: "",
    newCase: "",
    newWellsky: "",
    newDiagnoses: "",
    newState: "",
    newAdaptiveEquipment: false,
    newAdaptiveDate: "",
    newEquipmentUsed: "",
    newDailyUse: false,
    newExplanation: "",
    newAddress: "",
    newCity: "",
    newAddressState: "",
    newZip: "",
    states: ["Utah", "Nevada"],
    status: ["Active", "Inactive"],
    textFieldProps: {
      appendIcon: "event",
    },
    startDateProps: {
      min: moment(new Date()).format("YYYY-MM-DD"),
    },
    startTimeProps: {
      ampmInTitle: true,
    },
    endTimeProps: {
      ampmInTitle: true,
    },

    isLoading: true,
    showButton: false,
    reportFilters:  {
      ClientStatus: 'Active'
    },
    reportFilterName: 'ReportFilters_ClientList'
  }),

  computed: {},

  created() {
    this.getClients();
    this.reportFilters = this.getReportFilters(this.reportFilterName) ?? this.reportFilters;
  },
  watch: {
    reportFilters: {
        handler(newVal) {
            this.setReportFilters(this.reportFilterName, newVal);
        },
        deep: true
    }
  },

  methods: {

    initialize() {
      this.clients = [];
    },

    getClients() {
      this.isLoading = true;

      const companyIds = localStorage.getItem("userCompanies");

      let queryParams = {
        "Status[eq]": this.reportFilters.ClientStatus,
        Company: JSON.parse(companyIds),
        State: this.userState,
        additionalQueryData: [], //make blank as default
      };

      axios
        .get(`${url}/clients/state/${this.userState}`, {
          params: queryParams,
        })
        .then((res) => {
          this.clients = res.data.clients;
          for (var i = 0; i < this.clients.length; i++) {
            var dt = new Date(this.clients[i].AdmissionDate);
            this.clients[i].AdmissionDate =
              moment(dt).format("MM-DD-YYYY hh:mm a");
          }
          this.getUnits();
          this.getCodes();
        })
        .finally(() => (this.isLoading = false));
    },

    async printReport() {
      try {
        const companyIds = localStorage.getItem("userCompanies");

        let headerFields = this.headers
                .filter((header) => header.value != "actions")
                .map((header) => header.value)
                .join(", ");

        let query = {
          "Status[eq]": this.reportFilters.ClientStatus,
          Company: JSON.parse(companyIds),
          State: this.userState,
          additionalQueryData: {
            headers: headerFields,
            print: 'generate',
            route: 'clients'
          }
        };

        this.getReport(query)

      } catch (error) {
        console.log(error);
      }
    },

    getUnits: function () {
      axios.get(`${url}/units`).then(async (res) => {
        this.units = res.data.units;
      });
    },
    getCodes: function () {
      axios.get(`${url}/codes`).then(async (res) => {
        this.codes = res.data.codes;
      });
    },

    close() {
      this.dialog = false;
    },

    viewClient(item) {
      this.titleForm = "Viewing " + item.Name;
      this.dialog = true;
      this.editClient = true;
      this.newClient = false;
      this.newName = item.Name;
      this.newAdmissionDate = new Date(item.AdmissionDate);
      this.newServiceCode = item.ServiceCode;
      this.newProgram = item.Program;
      this.newBio = item.Bio;
      this.newBirthday = moment(item.Birthday).format("YYYY-MM-DD");
      this.newAge = item.Age;
      this.newGender = item.Gender;
      this.newEthnicity = item.Ethnicity;
      this.newAllergies = item.Allergies;
      this.newBehaviors = item.Behaviors;
      this.newMedicare = item.Medicare;
      this.newMedicaid = item.Medicaid;
      this.newPID = item.PID;
      this.newCase = item.Case;
      this.newWellsky = item.Wellsky;
      this.newDiagnoses = item.Diagnoses;
      this.clientID = item._id;
      this.newState = item.State;
      this.newAdaptiveEquipment = item.AdaptiveEquipment;
      this.newAdaptiveDate = item.AdaptiveDate;
      this.newEquipmentUsed = item.EquipmentUsed;
      this.newDailyUse = item.DailyUse;
      this.newExplanation = item.Explanation;
      this.newAddress = item.Address;
      this.newCity = item.City;
      this.newAddressState = item.AddressState;
      this.newZip = item.Zip;
    },

    updateClient() {
      var req_body = {
        Name: this.newName,
        AdmissionDate: this.newAdmissionDate,
        ServiceCode: this.newServiceCode,
        Program: this.newProgram,
        Bio: this.newBio,
        Birthday: this.newBirthday,
        Age: this.newAge,
        Gender: this.newGender,
        Ethnicity: this.newEthnicity,
        Allergies: this.newAllergies,
        Behaviors: this.newBehaviors,
        Medicare: this.newMedicare,
        Medicaid: this.newMedicaid,
        PID: this.newPID,
        Case: this.newCase,
        Wellsky: this.newWellsky,
        Diagnoses: this.newDiagnoses,
        State: this.newState,
        AdaptiveEquipment: this.newAdaptiveEquipment,
        AdaptiveDate: this.newAdaptiveDate,
        EquipmentUsed: this.newEquipmentUsed,
        DailyUse: this.newDailyUse,
        Explanation: this.newExplanation,
        Address: this.newAddress,
        City: this.newCity,
        AddressState: this.newAddressState,
        Zip: this.newZip,
      };
      axios
        .put(`${url}/clients/${this.clientID}`, req_body)
        .then((response) => {
          this.getClients();
          // this.getSpecificClients();
          if (response.status == 400) {
            response.json().then(function (data) {
              alert(data.msg);
            });
          }
          this.msg = true;
          this.text = "The client has been updated successfully.";
        });
      this.isLoading = true;
      this.close();
    },

    onSelectItem() {
      this.getClients();
    },

    printTable() {
      window.print();
    },
  },
};
</script>
<style>
#print {
  display: none;
}

@media only screen and (min-width: 768px) {
  .mobile {
    display: none;
  }
}

@media only screen and (max-width: 600px) {
  .desktop {
    display: none;
  }
}

@media only screen and (min-width: 768px) {
  .mobile {
    display: none;
  }
}

@media only screen and (max-width: 600px) {
  .desktop {
    display: none;
  }
}

@media print {
  #print {
    display: block;
    border: none;
    width: 1200px;
    padding-right: 300px;
    margin-left: -200px;
  }

  nav.v-navigation-drawer,
  header.v-toolbar,
  button.v-btn,
  div.v-card {
    display: none;
    border: none;
  }

  @page {
    margin: 0;
  }
  body {
    margin: 1.6cm;
  }
}
</style>
